module.exports = __webpack_public_path__ + "media/icons/check-ba34501f.png";